<template>
  <div id="table-list">
    <h2>DynamoDB Tables</h2>
    <ul>
      <li v-for="table in tables" :key="table">
        <router-link :to="'/table/' + table">{{ table }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        tables: []
      }
    },
    computed: mapGetters({
      ddb: 'getDynamoDB',
      amazonAuthenticated: 'amazonAuthenticated'
    }),
    watch: {
      ddb: function () { this.fillTables() }
    },
    methods: {
      fillTables: function () {
        if (!this.ddb) return
        var self = this

        this.ddb.listTables({}, function (err, data) {
          if (err) {
            console.log(err, err.stack) // an error occurred
          } else {
            self.tables = data.TableNames
          }
        })
      }
    },
    mounted: function () {
      if (!this.amazonAuthenticated) {
        this.$router.push('/unlock-secret')
        return
      }

      this.fillTables()
    }
  }
</script>
<style lang="less">
  #table-list ul {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/TableList.vue